enum DealershipFamily {
  Cdjr = 'cdjr'
}

export default DealershipFamily;
